var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo 2075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2942",
    d: "M10.2641 1.72672L7.78038 4.25664C7.76191 4.27511 7.76191 4.30281 7.78038 4.32128L9.51854 6.17255C9.63627 6.29028 9.63627 6.47956 9.51854 6.59728C9.46083 6.65499 9.38235 6.685 9.30618 6.685C9.23 6.685 9.15152 6.65499 9.09381 6.59728L7.36257 4.75293C7.3441 4.73447 7.3141 4.73447 7.29563 4.75293L6.87321 5.18228C6.52003 5.54007 6.05144 5.73859 5.54823 5.7409C5.03809 5.7432 4.55334 5.52853 4.19555 5.16612L3.78928 4.75293C3.77082 4.73447 3.74081 4.73447 3.72234 4.75293L1.9911 6.59728C1.93339 6.65499 1.85491 6.685 1.77873 6.685C1.70256 6.685 1.62408 6.65499 1.56637 6.59728C1.44864 6.47956 1.44864 6.29028 1.56637 6.17255L3.30454 4.32127C3.32069 4.30281 3.32069 4.27511 3.30454 4.25664L0.818473 1.72672C0.788465 1.69671 0.73999 1.71749 0.73999 1.75904V6.82119C0.73999 7.22746 1.07239 7.55985 1.47865 7.55985H9.60395C10.0102 7.55985 10.3426 7.22746 10.3426 6.82119V1.75904C10.3426 1.71749 10.2918 1.69902 10.2641 1.72672Z",
    fill: "#B79D5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2943",
    d: "M5.54129 5.13889C5.88292 5.13889 6.20378 5.00501 6.44385 4.76033L10.0656 1.07394C9.93865 0.97237 9.78168 0.912354 9.60856 0.912354H1.47633C1.30321 0.912354 1.14394 0.97237 1.01929 1.07394L4.64105 4.76033C4.8788 5.0027 5.19966 5.13889 5.54129 5.13889Z",
    fill: "#B79D5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.06ecc83f92af40a5203b4079184db513.svg";
export { ForwardRef as ReactComponent };